import React from "react";

const LogOut = () => {
  return (
    <div className="w-[563px] h-[308px] rounded-[10px] bg-white flex flex-col items-center justify-center shadow-[0_0px_0px_1px_rgba(0,0,0,0.07)]">
      <p className="w-[124px] h-[124px] rounded-full bg-[#FEECD4] flex items-center justify-center">
        <svg
          width="48"
          height="48"
          viewBox="0 0 48 48"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clip-path="url(#clip0_1570_19058)">
            <mask
              id="mask0_1570_19058"
              maskUnits="userSpaceOnUse"
              x="0"
              y="0"
              width="48"
              height="48"
            >
              <path d="M0 0H47.5V47.5H0V0Z" fill="white" />
            </mask>
            <g mask="url(#mask0_1570_19058)">
              <path
                d="M27.5 42C27.5 42.9946 27.1049 43.9484 26.4017 44.6517C25.6984 45.3549 24.7446 45.75 23.75 45.75C22.7554 45.75 21.8016 45.3549 21.0983 44.6517C20.3951 43.9484 20 42.9946 20 42C20 41.0054 20.3951 40.0516 21.0983 39.3483C21.8016 38.6451 22.7554 38.25 23.75 38.25C24.7446 38.25 25.6984 38.6451 26.4017 39.3483C27.1049 40.0516 27.5 41.0054 27.5 42Z"
                fill="black"
              />
              <path
                d="M27.5 30C27.5 30.9946 27.1049 31.9484 26.4017 32.6517C25.6984 33.3549 24.7446 33.75 23.75 33.75C22.7554 33.75 21.8016 33.3549 21.0983 32.6517C20.3951 31.9484 20 30.9946 20 30V6.25C20 5.25544 20.3951 4.30161 21.0983 3.59835C21.8016 2.89509 22.7554 2.5 23.75 2.5C24.7446 2.5 25.6984 2.89509 26.4017 3.59835C27.1049 4.30161 27.5 5.25544 27.5 6.25V30Z"
                fill="black"
              />
            </g>
          </g>
          <defs>
            <clipPath id="clip0_1570_19058">
              <rect width="47.5" height="47.5" fill="white" />
            </clipPath>
          </defs>
        </svg>
      </p>

      <p className="w-[253px] h-[23px] text-black font-semibold text-[15px] mt-[26px]">
        Are you sure you want to logout ?
      </p>

      <div className="flex flex-row gap-x-[19px] mt-[26px]">
        <button className="w-[95px] h-[42px] rounded-[10px] font-medium text-[14px] flex items-center justify-center border shadow-[0_0px_0px_1px_rgba(0,0,0,0.07)]">
          Yes
        </button>

        <button className="w-[99px] h-[42px] font-semibold text-[14px] bg-[#FF6300] text-white rounded-[10px]">
          No
        </button>
      </div>
    </div>
  );
};

export default LogOut;
